
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexdkDLXzZEvDJ469msafCbL_458Xp7LcTIuil1bJzG617x4Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/index.vue?macro=true";
import { default as loginO2CwgGwjMKGsqhjwXStXoIwgCwWwBSa6skMj82gpLTsMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/login.vue?macro=true";
import { default as mgen8IYFb6BGenFif9qWA31Ck0LkLGFLLs0fK_OJxaAm9noMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/quiz/mgen.vue?macro=true";
import { default as index3lb_aQ1JgFaZha9TNWldKY__F_4519eWYPY_dgd92mvWwMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/index.vue?macro=true";
import { default as noteswJmsSsxibKdTKjyy5Kk86jbwEyp42d6d6F8KlOxSexUMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/notes.vue?macro=true";
import { default as indexdPbCZaBdejoIwiR6Y_45IsSbPky4wjMSPJvHXB8fX7S2gMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/stats/index.vue?macro=true";
import { default as en_45ce_45momentRMjiQuLWV1Fbm56XMkEVRkHjyn71tyET_A6AGHCYPkEMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/en-ce-moment.vue?macro=true";
import { default as plan_45du_45sitenSplDb9089UwW9vIDlsN4oWDsO__IS5t98Gm208YB1sMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/plan-du-site.vue?macro=true";
import { default as edit4hlultD7N7xc0O_45jyrrZxpePYaCM2mMi4PSFGFw_PLwMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/profile/edit.vue?macro=true";
import { default as placesW43emkrZOLJ1gEPvg5fSo6QK8i5_chID7aUeWnZ0PsQMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/stats/places.vue?macro=true";
import { default as accessibiliteFdKrQiMaBOmQmm8b6vpYs9xVdqqlaSNRSRp0aCQiKMkMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/accessibilite.vue?macro=true";
import { default as _91id_93Nfs2FbEeq4v5nIroqvzfxE3hIt6PvTvo2AM9fazNfoIMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/messages/[id].vue?macro=true";
import { default as notificationsOdcFdYD9vbfi28CbSgKEhHighHCUaiw_45VRy7Zdk7iDQMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/notifications.vue?macro=true";
import { default as indexW2Erbgc1I_Bk8BHfaC2s5vyJb9kw4PPHeMsulPw3JmkMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/profile/index.vue?macro=true";
import { default as indexzZqUuvzT2EQ3amsfGxSD5_45X2Tq82pnGHfhN_Kp3tZ3EMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/index.vue?macro=true";
import { default as _91slug_93QqDFiIyImg88xs0eG1xaJkoPti9mI2goOzR1C4fuvY4Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/villes/[slug].vue?macro=true";
import { default as indexn0wW2Z7v3GtNvWdsal40NlzjQM8_45GAnTL41_T875EGQMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/messages/index.vue?macro=true";
import { default as generiqueAfZ4iJwq_45rMIX3GJJ_Wfi5OmE6MwbXI0eZKrPq_45lwqsMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/quiz/generique.vue?macro=true";
import { default as _91slug_93zdwPU_45kh7iXTD7M0JmqxcPPUs_45vqnkYJCJXhYm6JUzYMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/reseaux/[slug].vue?macro=true";
import { default as missionsEK7JU56sUXABIkQt9XtDidZDqt8_umBt_45GuYGqXxMVQMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/stats/missions.vue?macro=true";
import { default as indexV1iPXa4vx_45rtFLsNMoxRkgul6sd_ZlLC0uXbQxuMG00Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/dashboard/index.vue?macro=true";
import { default as favorisgYxWVeDRTU1aFhtIcli1c3QlQB_PEGcYvzGs0LjRTtoMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/profile/favoris.vue?macro=true";
import { default as _91slug_93zajcSbifAMVA2OQ1GXvAeqsJv_45PJF95G_45VT0a_YzQ10Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/activites/[slug].vue?macro=true";
import { default as logsp7w_YO6OOIxOi_xxTa_Izhtgai_45dCHpW7p2HfBZ_MxkMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/other/logs.vue?macro=true";
import { default as ressourcesYDRALzSnWy_ll4LjfZ0Vpkcwe0e66NwhxvcgWkUJgyIMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/ressources.vue?macro=true";
import { default as mentions_45legalesqvSuAgWEIjAgoBGxSUU6g9gu3akqbc_PwK3k7N11NWgMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/mentions-legales.vue?macro=true";
import { default as missionsWTZWtLBY42VB0jj1uXd_2OTZ9zqByeiqWV3ZW9CGeVMMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/profile/missions.vue?macro=true";
import { default as settings1x3C_45WDCST8X0PYMyi8f7aKTEIWbpDBIxQyfQ3wicw4Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/profile/settings.vue?macro=true";
import { default as temoignagesgta0HYkChYV6kMW_45IouKCELTLTW1Ppn8fEBUlr_VmbEMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/temoignages.vue?macro=true";
import { default as index16DJqd0JS7rDsChO5Y_fbC5nIs0hINQfGjguSw8ukE4Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/index.vue?macro=true";
import { default as adminw616jIz9sL8eYC50jahXlXgrsWoY7Ek6tjx8vwl6kqQMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/maintenance/admin.vue?macro=true";
import { default as indexdXzgsbieNo_4527NVYgQn7K7Q3UZEBA2_kRb2HleIkh_oMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/maintenance/index.vue?macro=true";
import { default as indexLjHbzMhVGoae_45Pbn_TwyGxLoOLlwACX8rI1XBW_ns2EMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/territoires/index.vue?macro=true";
import { default as _91hash_93Sr9WBqUwHi_45_4515TyHJZoyQPWo1SP3FxxIHPThzTxQ1kMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/invitations/[hash].vue?macro=true";
import { default as utilisateursyromjZTI3SqmOXFoXxNoB4MwUTfuHvLck5nIlfm3BN8Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/stats/utilisateurs.vue?macro=true";
import { default as _91slug_93Vu_45vN95ypf7JQ9qY5Wng8fvt673wTLwkk5p8fvXKj_IMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/associations/[slug].vue?macro=true";
import { default as _91slug_93smMX2rtky5oAtuW_5JNT1bm3BEsuTD5gCS0SuH8jfU4Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/departements/[slug].vue?macro=true";
import { default as indexj9gSTZIwsda7HbGecl_nYBe9NZvIoKZrX67M7prv1MIMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/organisations/index.vue?macro=true";
import { default as preferencesbkIuBalC4MlmY5uPxajtyW0r5ijMwOrbS4CX0o9gtJoMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/profile/preferences.vue?macro=true";
import { default as organisationst4WKnqakaUMOlkmN6A3Xb_fwE_tHPpTsRH_45nCXZHsnoMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/stats/organisations.vue?macro=true";
import { default as _91token_93QsTu4Qqd421vpZuUtTRLUgGvu7_cWwCWD9WsO9WkgskMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/temoignages/[token].vue?macro=true";
import { default as postsIy1ZXVw6X9u7iB9yzLaSIfkwtcSk_8eCyZ94IC0dNyQMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/posts.vue?macro=true";
import { default as index5fGKBzMLpNm9euTb1IY5Exv4DAfdIOSabh1_hF78Xo4Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/index.vue?macro=true";
import { default as addwme52muqMo9DoliuL3vOAdP_YEhWg5aiMy5Q3pNY_45wUMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/messages/modeles/add.vue?macro=true";
import { default as _91slug_93_CJQQi1DO9qu7YMmOnGDS0fCoy_45naT6aIquENLmZWTUMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/organisations/[slug].vue?macro=true";
import { default as indexM99OcNXiWrwGndBTbKejA3ZI_v3cbgqtuNNXXoPcE9AMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/password-reset/index.vue?macro=true";
import { default as participations55DEAMkXEjUF1qQn6_JjdAzWzkg1v2jqSWyHlbbblsQMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/stats/participations.vue?macro=true";
import { default as emails3BoXoryYsPACNX1Iz_iZR10kxD_4NLUGhsHgilF0hmIMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/settings/emails.vue?macro=true";
import { default as indexEi8GQll4iDc28uG53HULa7SRvzNDp7vTV3Nj_45tN9xXcMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/profile/alertes/index.vue?macro=true";
import { default as notificationsgS_45XBDkSP5EP_45jPydOEmdjZKxISNGNR3wrNC1VN0XNcMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/profile/notifications.vue?macro=true";
import { default as indexJoUGUHzWGWIF8SEtchef_45ev0Qm0Z3TXCe_je5OXV6LsMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/index.vue?macro=true";
import { default as charte_45reserve_45civiqueS3ihdi15AWGxbsvlKVxR9_biO88qgOtZOZW6z5HVb1AMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/charte-reserve-civique.vue?macro=true";
import { default as _91slug_93pAUw42EtpP9cUVMEgIX0fhV_rfPLLY6hTjFuOjlrhokMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/domaines-action/[slug].vue?macro=true";
import { default as indexF8OYTmqegFVcrLlbqewA6buZr5OmkZF9sLxMg2r4STAMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/messages/modeles/index.vue?macro=true";
import { default as _91token_93ob_Ruw70R_cvdKfQcp3AayopXfMGmpXI16fS1U4I0_45IMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/password-reset/[token].vue?macro=true";
import { default as decembre_45ensembleV9G_45d3DAnCzxRgEWMOQbW_WZj76ZwoFRCCzsDFZT804Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/quiz/decembre-ensemble.vue?macro=true";
import { default as invitationsA4b9pHmHuk510K6fH7ykz59Vr_452ABSKovXT_BTvbjfUMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/other/invitations.vue?macro=true";
import { default as messagesPiTpMe5fAuJozLKomn3ckkfd7QUs6XEjioNZ3UcFglUMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/settings/messages.vue?macro=true";
import { default as placesNMw_qGPWa8fGYmyN5pjKDVIITq7IWks2rRdEFQr0EMMMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/places.vue?macro=true";
import { default as adddVbvCMC_NrP9WdlXJBtkFKpC7EsMBHOQ_45mfpqoJ_k14Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/settings/rules/add.vue?macro=true";
import { default as indexM_BeeI1yWwYmbwmXXBh2l6HtEIRAQINfuLOcnPWqYsEMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/utilisateurs/index.vue?macro=true";
import { default as indexlGtxNYW9UxCXoZ6vbN_G_pHccLPeZ8tY3gwAWto_NXwMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/missions-benevolat/index.vue?macro=true";
import { default as dates3p_jvQfsN5RcNhP7Of152DotkuClX5GLwN3tBvMaD_wMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/[id]/dates.vue?macro=true";
import { default as index7cQVT529nOehlUnmdKy84NnTS9s8xEgkA9_jPHUrD1wMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/[id]/index.vue?macro=true";
import { default as lieuxqix6BFAwqnpBU_45LJpod28bNmU0ngG75zEDckevfasFAMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/[id]/lieux.vue?macro=true";
import { default as titleN7BmfYD3S_45aIWbGyAG6Q2BZFTNgIlCK4d4pDjK5L50cMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/[id]/title.vue?macro=true";
import { default as index3wt4iU8kHNfCkf_45sNCDbaNz64hMHGbyjWzqKXLXPm2oMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/organisations/index.vue?macro=true";
import { default as missions6BysHbOAApINS6fDRMvsQAmLPRiwd8T_R3EA_452pC1SIMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/missions.vue?macro=true";
import { default as addtH78xybE0k2wW4XaDBzRfOWrTz4OfKdw1dFo1Bz5sWAMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/reseaux/add.vue?macro=true";
import { default as visuel9DfUBRVznS8LBqOgn_GtGVwPevieZlIHfvcJNcM5WLkMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/[id]/visuel.vue?macro=true";
import { default as indexTOYw20j0H0TANtC1Mkr4MVWLaTYGvkilW1XpVbsrwuMMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/participations/index.vue?macro=true";
import { default as indexvolQW_zXnknBAyhx8hfY9NP3KJwdGEThmDujRwdwafsMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/settings/rules/index.vue?macro=true";
import { default as indexjLMpKgk0obEyqujxGQj3HOjVbw4VZjcoj6iVnuhDr24Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/benevole/index.vue?macro=true";
import { default as addWQrntMSbbDxFyOpQ4dcplTOvZhhqzKTS_DaMyqrvAlUMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/domaines/add.vue?macro=true";
import { default as addF0IjYdvzCsLMrO2PK3fqCMmsjWoRGrPMt9BIftFRJ_QMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/taxonomies/[slug]/add.vue?macro=true";
import { default as addYZtwZa42utzqrkUnAOkeJfwqZdRi9vmav_45xzgj22mSAMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/activites/add.vue?macro=true";
import { default as indexa_lsTStYvqKdTqrSk0sse0LOWdsmQD3_Lg5wZwb5LewMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/reseaux/index.vue?macro=true";
import { default as conversionsN_45CP5oGIpbj2i0PjnPXgOge4b1wGy3gG6gSv8hjXfGcMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/conversions.vue?macro=true";
import { default as editn_45n_Dz77HiWN425rYHH7YMgE298vqFvXu7u4GbEArs0Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/utilisateurs/[id]/edit.vue?macro=true";
import { default as politique_45de_45confidentialiterxUNWgEs5QBMx0aqDWg5gHPqk0uu_5f01_45QeXVdsLKQMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/politique-de-confidentialite.vue?macro=true";
import { default as indexTErOVgyjnzKqVPhFRnePbMjhu43NdK0_tsKNESXb5QAMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/domaines/index.vue?macro=true";
import { default as addRz_454UB5F9MYqToa3zYTlF0A32pLJJpMTGsFYnBqwpcQMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/ressources/add.vue?macro=true";
import { default as benevolesNLGqOPA6zHCVsqawOsg2aqNjs6UU8iaHIGllq0Vg_45dYMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/[id]/benevoles.vue?macro=true";
import { default as editaJ9lhNiJib2K9pvdm7xqNx1vWzsnFhgKRaddQg7qBOEMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/organisations/[id]/edit.vue?macro=true";
import { default as utilisateursftk6GABJd3XAVd1g2r_45ZI_45refsMERf1dLWZWVmHlyLgMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/utilisateurs.vue?macro=true";
import { default as indexMxCVwspsbjUuQYr1xeQ_45voOyBcQqSijwT5jFi8XJshsMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/taxonomies/[slug]/index.vue?macro=true";
import { default as indexSEeyegOLd_45hSRv7pYIQAuSXnU1dHs8l2cxZbbrtdWtsMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/utilisateurs/[id]/index.vue?macro=true";
import { default as indexFLGL5IH8qqFlWny_450gC0IN6MND0lllwBfiMXcanqRd8Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/responsable/index.vue?macro=true";
import { default as indexfrswV4elC2De8uV7AqBzXvhopyfSbFJa2iRzdpAd_45zAMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/missions-benevolat/[id]/index.vue?macro=true";
import { default as septembre_45pour_45apprendredFwYOsKGNCtN7hkP2y6EvA_45f8dIw5oQ6UdSU4Q6QY34Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/quiz/septembre-pour-apprendre.vue?macro=true";
import { default as indexIsxRdFgAYBAtx51I_45v1eQAc6iTb5zQRVOmLNS5D8lc0Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/activites/index.vue?macro=true";
import { default as addTCRRqW_45O5fhW_PBhACUDtOZPpBcMvUNqhs5pccjBNfUMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/territoires/add.vue?macro=true";
import { default as indexV1Quc71cnbxeL8ejswvSi1_U1QhMCr34qxjqFmIHSLQMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/organisations/[id]/index.vue?macro=true";
import { default as editEGGOkzQg3HT97TWcAMT27i7liqwUTufjiGFD92TfzcYMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/settings/rules/[id]/edit.vue?macro=true";
import { default as _91slug_93OlEdpE_Cf_45zCbCPspaZGYJHxPb3A3TiQ4ckbUv0VEHIMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/missions-benevolat/[id]/[slug].vue?macro=true";
import { default as printemps_45pour_45la_45planeteMM6WGG_45jPnHijB1L_45glRAyohdqbT0e16iwoCESZovxYMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/quiz/printemps-pour-la-planete.vue?macro=true";
import { default as index0TMpD2Pb3mHSlns7e1DpY_Ew66l5hmM4VoSzrt9S_P8Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/ressources/index.vue?macro=true";
import { default as participations4GYDe_45uNf02oMV82Gioq6Fw8t74QmrMb5Joe0QF_FkgMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/participations.vue?macro=true";
import { default as indexzXJBK7XYfREBm4fTGArFUS2ush4Pb1MgfIwna_aGJygMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/charte-bon-fonctionnement/index.vue?macro=true";
import { default as activity_45logsyC5Fpk9AvXM2tSbbl6mNvWY_p9u7VKEXcuX0IXyB_450kMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/referents/activity-logs.vue?macro=true";
import { default as edit6yEiTwiTkNiRjfWPmH51fYOZeS8vthI8m1iPrYsJUj8Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/reseaux/[id]/edit.vue?macro=true";
import { default as indexM8Rd2cVWaET1bt07MYCzTaFGzgA2SQC5cZj6tUfgh2IMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/territoires/index.vue?macro=true";
import { default as informationsYFHFFb9dsBDnAFQjxDuqzLqaglo13XZAIpBi6yWHqdwMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/[id]/informations.vue?macro=true";
import { default as responsablespys25eAVhOtpGT5TGHIFQ7VT1RUeNQIc7rrhlj5F658Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/[id]/responsables.vue?macro=true";
import { default as editmJYkBRvSaXK90_icqFDNf4gWsJ3ZCQdzwG3bOGX1wJQMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/domaines/[id]/edit.vue?macro=true";
import { default as indexOKRPQk4V1_8FysKE2HNTCIfpjDogwMrQAHnVKObDFosMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/reseaux/[id]/index.vue?macro=true";
import { default as indexMfYgtrFLgTzLB9E1EEB9mWH_45aGCeWDOFqgDifYYRyJsMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/testimonials/index.vue?macro=true";
import { default as indicateurs_45clesVyo7TM_rD5cuSsnOEyesbA3q2lETLL19fdhOlwGcz6MMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/indicateurs-cles.vue?macro=true";
import { default as editOqRYjZ7EMAGlPe_J3e8Dtf74yBefWhx8DIl9iaw03c4Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/taxonomies/[slug]/[id]/edit.vue?macro=true";
import { default as profile_45m4mqdTlBACEGt8Wal8LF_45klMEnDQXr_p2RzVbEWtPgMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/benevole/step/profile.vue?macro=true";
import { default as charte_45bon_45fonctionnementnWv_Bi4BAXOgPcwBedInTTp4H9rd_zxKgIqR14AjBDwMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/profile/charte-bon-fonctionnement.vue?macro=true";
import { default as waiting_45actionsKlpptDdr0MjGVO9C7Bgh473O9MuR_45GBElySKonc0a7wMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/referents/waiting-actions.vue?macro=true";
import { default as editDv1lwHLHtPnVisVk3ottu7WZ3S78QiJ8b98E5XxKzrkMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/activites/[id]/edit.vue?macro=true";
import { default as add0SYxN_45gdyMbXILGILHOOi8n6LQvte3eensNqQaNxUq0Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/modeles-mission/add.vue?macro=true";
import { default as conditions_45generales_45d_45utilisationwDaUbqHg4RXzd3GoX_45FS_OzuEWXrj1v54V89pi0IhncMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/conditions-generales-d-utilisation.vue?macro=true";
import { default as indexzDGSzXONQaiXGanH8ZxobiPcNFVA0hQ3s8TTdEDTXx8Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/activites/[id]/index.vue?macro=true";
import { default as edit6VZ_45Uc3qT5V_45bjJ_45icNTpfGkOEyPdmvL_2vMa9acl3YMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/ressources/[id]/edit.vue?macro=true";
import { default as diffusionsMchfQ8r_45_s36d22mvj729LOKLaSCpJeDyXoV_i0sGGgMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/organisations/[id]/diffusions.vue?macro=true";
import { default as moderationsnokRaaritOTHmB_VQq5RS0kAY_PsmsPdzNK3lzT68YMMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/suivis/moderations.vue?macro=true";
import { default as benevoles7RBdPw6p_97aCFE8H1BLK4jchKyoaT1TersmA9yud1sMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/charte-bon-fonctionnement/benevoles.vue?macro=true";
import { default as google_45api_45indexingkXk73qF_A3eVYV0y6Id24S9_45Vf5nULm6SkhbWb6HK4gMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/actions/google-api-indexing.vue?macro=true";
import { default as indexj0MKAvi9IpcrTRKWSyGHq9JlLB6wtnRugx6_454z_45kafwMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/modeles-mission/index.vue?macro=true";
import { default as edit5UCVKYsAhE9tYUX4JCykvA4Gw6OFEeo5AZp20H1IfDIMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/territoires/[id]/edit.vue?macro=true";
import { default as indexWL4Wd6xJhhCgq1CNtn98MhTIL2c2xGpWkuN7b1MshNAMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/organisations/index.vue?macro=true";
import { default as profile5os_Id_45jEmKSwXnuXFTq1ZrQhnvSc4OwzKUMfaWVltQMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/responsable/step/profile.vue?macro=true";
import { default as indexEmmko_ReZAf8gRe1xkC62UeBMxR3FdKeD7LxKdsnPcsMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/territoires/[id]/index.vue?macro=true";
import { default as edit8GCyMfegZIBuaZUkd9Ie6U0YcS8LH8Esxp_45ZLhTgS88Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/testimonials/[id]/edit.vue?macro=true";
import { default as add_rfiHRw3T7zEz4jixNvbg65QokY72NxLMNmVppV_LiQMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/organisations/[id]/missions/add.vue?macro=true";
import { default as competencesSF8W_45EIKlfoQ6M68m5eo04CiybAxPfLOI9DnrhVlzO0Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/benevole/step/competences.vue?macro=true";
import { default as preferences79Mmfswvj3F569GwrvrVLkT0fsy_45T_gZq0KYXpcbzDgMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/benevole/step/preferences.vue?macro=true";
import { default as search_45archived_45usersR_YMvoFnUBsPMbvVPkoisdzNvw5sJINylW4kPQQnRYcMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/actions/search-archived-users.vue?macro=true";
import { default as doublons_45territoirese3jIafbNa0zeAPIsJaDWVn7Zr6CxAnuBk2JzpmvOC44Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/contents/doublons-territoires.vue?macro=true";
import { default as responsablesYIPtWOolbw9eDm6KDDcqobtDJAedUbOoQbsEZPZAOqYMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/charte-bon-fonctionnement/responsables.vue?macro=true";
import { default as transfert_45organisationDdK05i14QMRoRGPU_OnZLAdxUkUDhy_6SNuBhl_45RwUMMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/actions/transfert-organisation.vue?macro=true";
import { default as missions_45outdated78_sZorppGFn_wbXECcvHRPdW1owGnClpCbCdvLPLLgMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/responsables/missions-outdated.vue?macro=true";
import { default as pending_45itemsL9yJELOJngFsSPrA10BZTp_45Ij1WqrqAm5211QVYqgBMMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/settings/rules/[id]/pending-items.vue?macro=true";
import { default as user_45reset_45context_45roleuvobKi1LXC5mYgn0qFkH5inYz_45Noggq_45DN_45pi0axyNEMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/actions/user-reset-context-role.vue?macro=true";
import { default as doublons_45organisationsmL5EKdmXv3C5_VAexsekxAW7WOuQWuZ5Iepx_5VyWVsMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/contents/doublons-organisations.vue?macro=true";
import { default as editV809MJOB8tqU_ZShXGZlRSgvBJszBRnGy72DiPO5GXMMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/modeles-mission/[id]/edit.vue?macro=true";
import { default as disponibilitesV4aYHyphTdwm4_qnS37jGBPpzykEDZl1boizIwOkebUMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/benevole/step/disponibilites.vue?macro=true";
import { default as user_45reset_45password_45link10wXmspzbze9Zppk_45YbFw5CVYtQvJq8nUdRY3fau9doMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/actions/user-reset-password-link.vue?macro=true";
import { default as indexQTvGeck19EAsgwFgds2fcsXdHM6j7FwpPoK7hBgKxlEMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/modeles-mission/[id]/index.vue?macro=true";
import { default as collectivites3HavC0ZU3RCZd328IERsqKufzMd8Lj_wcnxabBfgJAMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/responsable/step/collectivite.vue?macro=true";
import { default as organisation7r_454fXwb1eXqV3aJgd_45_pkd8fKb8VsuRiS7JwZzQpYUMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/responsable/step/organisation.vue?macro=true";
import { default as benevoles_45informationsiuVD6VeAKj5xcbY2zoh6old55mqjPRIx7R4L_45cXq6pMMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/[id]/benevoles-informations.vue?macro=true";
import { default as trafic_45entrantWhAO0ss6MA3EA9v6GSPfLWygw05asl7o7GmubEEgfGMMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/api-engagement/trafic-entrant.vue?macro=true";
import { default as trafic_45sortantkw7njw6ElHsQWsUI0yt5v5_455iUHEAP3ib2sgg8VgIAAMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/api-engagement/trafic-sortant.vue?macro=true";
import { default as indexPt1KI7mrqwUjzeYd9yy96O9mF1QnqPm3AvGIVk6qbV8Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/[id]/trouver-des-benevoles/index.vue?macro=true";
import { default as missions_45perimeesvj_UFJSMB_45YFgsqbH6Zjg01C1jH45ZnXlpHX7mV4JhYMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/departements/missions-perimees.vue?macro=true";
import { default as missions_45a_45validerPnfJ7fyhORKXd7Or_45J0DrGzid9XoGKGhxd2cdXl0s_MMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/departements/missions-a-valider.vue?macro=true";
import { default as missions_45perimeesh4XZXxUIVaUlKQY_45oG7fx3EtJCpfUGwtKS39R_45HnzGgMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/organisations/missions-perimees.vue?macro=true";
import { default as organisation_45imagesOugXxGWJ0SU2iqgjNjqidBCEp4eOfGAuF38LQ0uwkn4Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/responsable/step/organisation-images.vue?macro=true";
import { default as organisation_45details4BCP1wbuNG21CYP_45l6c5vjywqeg9H42oSAXEdaJsgvQMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/responsable/step/organisation-details.vue?macro=true";
import { default as participations_45to_45be_45treated11_45w1gV24wzPxeOGo6PBdVlH_DEQ_45Rc0F_fqrR62al4Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/responsables/participations-to-be-treated.vue?macro=true";
import { default as redirectR_45hsoWJlxiGHsv4isG1gKlvtAmKKUvYNkiEX_45N9utOAMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue?macro=true";
import { default as organisations_45a_45valideraXaZQzan0tEWY5DdLdKGCvscRz1NiCywCPEr9wWl5CwMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/departements/organisations-a-valider.vue?macro=true";
import { default as charte_45bon_45fonctionnementp6ikZAucatXHIyfGXUSvdg0YaAwqipcG9shI1YVQbGkMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/responsable/step/charte-bon-fonctionnement.vue?macro=true";
import { default as collectivite_45confirmationdjtRzN8n3aa8pvH_45XZQ3yPQ9c_uW8zulUvJtKF88NtcMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/responsable/step/collectivite-confirmation.vue?macro=true";
import { default as organisation_45confirmationDeiH2BF10XFWpfxKkRjfmvJPuuWxAJsPBNzOL_45HxwE8Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/responsable/step/organisation-confirmation.vue?macro=true";
import { default as participations_45a_45validerRsa8w8RDup5s9vwc9yhRxuvQvRpnawgsFaKNHEjM6_AMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/organisations/participations-a-valider.vue?macro=true";
import { default as participations_45refusees_45annuleeskc5V5N868TqPd_45XS3dS_a9xAx2hrq4MmxuPYmqwick8Meta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/organisations/participations-refusees-annulees.vue?macro=true";
import { default as component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTkMeta } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTk } from "/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginO2CwgGwjMKGsqhjwXStXoIwgCwWwBSa6skMj82gpLTsMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/login.vue")
  },
  {
    name: "quiz-mgen",
    path: "/quiz/mgen",
    meta: mgen8IYFb6BGenFif9qWA31Ck0LkLGFLLs0fK_OJxaAm9noMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/quiz/mgen.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: index3lb_aQ1JgFaZha9TNWldKY__F_4519eWYPY_dgd92mvWwMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/index.vue")
  },
  {
    name: "admin-notes",
    path: "/admin/notes",
    meta: noteswJmsSsxibKdTKjyy5Kk86jbwEyp42d6d6F8KlOxSexUMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/notes.vue")
  },
  {
    name: "stats",
    path: "/stats",
    meta: indexdPbCZaBdejoIwiR6Y_45IsSbPky4wjMSPJvHXB8fX7S2gMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/stats/index.vue")
  },
  {
    name: "en-ce-moment",
    path: "/en-ce-moment",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/en-ce-moment.vue")
  },
  {
    name: "plan-du-site",
    path: "/plan-du-site",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/plan-du-site.vue")
  },
  {
    name: "profile-edit",
    path: "/profile/edit",
    meta: edit4hlultD7N7xc0O_45jyrrZxpePYaCM2mMi4PSFGFw_PLwMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/profile/edit.vue")
  },
  {
    name: "stats-places",
    path: "/stats/places",
    meta: placesW43emkrZOLJ1gEPvg5fSo6QK8i5_chID7aUeWnZ0PsQMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/stats/places.vue")
  },
  {
    name: "accessibilite",
    path: "/accessibilite",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/accessibilite.vue")
  },
  {
    name: "messages-id",
    path: "/messages/:id()",
    meta: _91id_93Nfs2FbEeq4v5nIroqvzfxE3hIt6PvTvo2AM9fazNfoIMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/messages/[id].vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationsOdcFdYD9vbfi28CbSgKEhHighHCUaiw_45VRy7Zdk7iDQMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/notifications.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexW2Erbgc1I_Bk8BHfaC2s5vyJb9kw4PPHeMsulPw3JmkMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/profile/index.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: indexzZqUuvzT2EQ3amsfGxSD5_45X2Tq82pnGHfhN_Kp3tZ3EMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/index.vue")
  },
  {
    name: "villes-slug",
    path: "/villes/:slug()",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/villes/[slug].vue")
  },
  {
    name: "messages",
    path: "/messages",
    meta: indexn0wW2Z7v3GtNvWdsal40NlzjQM8_45GAnTL41_T875EGQMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/messages/index.vue")
  },
  {
    name: "quiz-generique",
    path: "/quiz/generique",
    meta: generiqueAfZ4iJwq_45rMIX3GJJ_Wfi5OmE6MwbXI0eZKrPq_45lwqsMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/quiz/generique.vue")
  },
  {
    name: "reseaux-slug",
    path: "/reseaux/:slug()",
    meta: _91slug_93zdwPU_45kh7iXTD7M0JmqxcPPUs_45vqnkYJCJXhYm6JUzYMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/reseaux/[slug].vue")
  },
  {
    name: "stats-missions",
    path: "/stats/missions",
    meta: missionsEK7JU56sUXABIkQt9XtDidZDqt8_umBt_45GuYGqXxMVQMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/stats/missions.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexV1iPXa4vx_45rtFLsNMoxRkgul6sd_ZlLC0uXbQxuMG00Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/dashboard/index.vue")
  },
  {
    name: "profile-favoris",
    path: "/profile/favoris",
    meta: favorisgYxWVeDRTU1aFhtIcli1c3QlQB_PEGcYvzGs0LjRTtoMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/profile/favoris.vue")
  },
  {
    name: "activites-slug",
    path: "/activites/:slug()",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/activites/[slug].vue")
  },
  {
    name: "admin-other-logs",
    path: "/admin/other/logs",
    meta: logsp7w_YO6OOIxOi_xxTa_Izhtgai_45dCHpW7p2HfBZ_MxkMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/other/logs.vue")
  },
  {
    name: "admin-ressources",
    path: "/admin/ressources",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/ressources.vue")
  },
  {
    name: "mentions-legales",
    path: "/mentions-legales",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/mentions-legales.vue")
  },
  {
    name: "profile-missions",
    path: "/profile/missions",
    meta: missionsWTZWtLBY42VB0jj1uXd_2OTZ9zqByeiqWV3ZW9CGeVMMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/profile/missions.vue")
  },
  {
    name: "profile-settings",
    path: "/profile/settings",
    meta: settings1x3C_45WDCST8X0PYMyi8f7aKTEIWbpDBIxQyfQ3wicw4Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/profile/settings.vue")
  },
  {
    name: "admin-temoignages",
    path: "/admin/temoignages",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/temoignages.vue")
  },
  {
    name: "inscription",
    path: "/inscription",
    meta: index16DJqd0JS7rDsChO5Y_fbC5nIs0hINQfGjguSw8ukE4Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/index.vue")
  },
  {
    name: "maintenance-admin",
    path: "/maintenance/admin",
    meta: adminw616jIz9sL8eYC50jahXlXgrsWoY7Ek6tjx8vwl6kqQMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/maintenance/admin.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: indexdXzgsbieNo_4527NVYgQn7K7Q3UZEBA2_kRb2HleIkh_oMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/maintenance/index.vue")
  },
  {
    name: "territoires",
    path: "/territoires",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/territoires/index.vue")
  },
  {
    name: "invitations-hash",
    path: "/invitations/:hash()",
    meta: _91hash_93Sr9WBqUwHi_45_4515TyHJZoyQPWo1SP3FxxIHPThzTxQ1kMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/invitations/[hash].vue")
  },
  {
    name: "stats-utilisateurs",
    path: "/stats/utilisateurs",
    meta: utilisateursyromjZTI3SqmOXFoXxNoB4MwUTfuHvLck5nIlfm3BN8Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/stats/utilisateurs.vue")
  },
  {
    name: "associations-slug",
    path: "/associations/:slug()",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/associations/[slug].vue")
  },
  {
    name: "departements-slug",
    path: "/departements/:slug()",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/departements/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/organisations/index.vue")
  },
  {
    name: "profile-preferences",
    path: "/profile/preferences",
    meta: preferencesbkIuBalC4MlmY5uPxajtyW0r5ijMwOrbS4CX0o9gtJoMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/profile/preferences.vue")
  },
  {
    name: "stats-organisations",
    path: "/stats/organisations",
    meta: organisationst4WKnqakaUMOlkmN6A3Xb_fwE_tHPpTsRH_45nCXZHsnoMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/stats/organisations.vue")
  },
  {
    name: "temoignages-token",
    path: "/temoignages/:token()",
    meta: _91token_93QsTu4Qqd421vpZuUtTRLUgGvu7_cWwCWD9WsO9WkgskMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/temoignages/[token].vue")
  },
  {
    name: "admin-contenus-posts",
    path: "/admin/contenus/posts",
    meta: postsIy1ZXVw6X9u7iB9yzLaSIfkwtcSk_8eCyZ94IC0dNyQMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/posts.vue")
  },
  {
    name: "admin-missions",
    path: "/admin/missions",
    meta: index5fGKBzMLpNm9euTb1IY5Exv4DAfdIOSabh1_hF78Xo4Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/index.vue")
  },
  {
    name: "messages-modeles-add",
    path: "/messages/modeles/add",
    meta: addwme52muqMo9DoliuL3vOAdP_YEhWg5aiMy5Q3pNY_45wUMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/messages/modeles/add.vue")
  },
  {
    name: "organisations-slug",
    path: "/organisations/:slug()",
    meta: _91slug_93_CJQQi1DO9qu7YMmOnGDS0fCoy_45naT6aIquENLmZWTUMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/organisations/[slug].vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: indexM99OcNXiWrwGndBTbKejA3ZI_v3cbgqtuNNXXoPcE9AMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/password-reset/index.vue")
  },
  {
    name: "stats-participations",
    path: "/stats/participations",
    meta: participations55DEAMkXEjUF1qQn6_JjdAzWzkg1v2jqSWyHlbbblsQMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/stats/participations.vue")
  },
  {
    name: "admin-settings-emails",
    path: "/admin/settings/emails",
    meta: emails3BoXoryYsPACNX1Iz_iZR10kxD_4NLUGhsHgilF0hmIMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/settings/emails.vue")
  },
  {
    name: "profile-alertes",
    path: "/profile/alertes",
    meta: indexEi8GQll4iDc28uG53HULa7SRvzNDp7vTV3Nj_45tN9xXcMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/profile/alertes/index.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    meta: notificationsgS_45XBDkSP5EP_45jPydOEmdjZKxISNGNR3wrNC1VN0XNcMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/profile/notifications.vue")
  },
  {
    name: "admin-statistics",
    path: "/admin/statistics",
    meta: indexJoUGUHzWGWIF8SEtchef_45ev0Qm0Z3TXCe_je5OXV6LsMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/index.vue")
  },
  {
    name: "charte-reserve-civique",
    path: "/charte-reserve-civique",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/charte-reserve-civique.vue")
  },
  {
    name: "domaines-action-slug",
    path: "/domaines-action/:slug()",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/domaines-action/[slug].vue")
  },
  {
    name: "messages-modeles",
    path: "/messages/modeles",
    meta: indexF8OYTmqegFVcrLlbqewA6buZr5OmkZF9sLxMg2r4STAMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/messages/modeles/index.vue")
  },
  {
    name: "password-reset-token",
    path: "/password-reset/:token()",
    meta: _91token_93ob_Ruw70R_cvdKfQcp3AayopXfMGmpXI16fS1U4I0_45IMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/password-reset/[token].vue")
  },
  {
    name: "quiz-decembre-ensemble",
    path: "/quiz/decembre-ensemble",
    meta: decembre_45ensembleV9G_45d3DAnCzxRgEWMOQbW_WZj76ZwoFRCCzsDFZT804Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/quiz/decembre-ensemble.vue")
  },
  {
    name: "admin-other-invitations",
    path: "/admin/other/invitations",
    meta: invitationsA4b9pHmHuk510K6fH7ykz59Vr_452ABSKovXT_BTvbjfUMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/other/invitations.vue")
  },
  {
    name: "admin-settings-messages",
    path: "/admin/settings/messages",
    meta: messagesPiTpMe5fAuJozLKomn3ckkfd7QUs6XEjioNZ3UcFglUMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/settings/messages.vue")
  },
  {
    name: "admin-statistics-places",
    path: "/admin/statistics/places",
    meta: placesNMw_qGPWa8fGYmyN5pjKDVIITq7IWks2rRdEFQr0EMMMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/places.vue")
  },
  {
    name: "admin-settings-rules-add",
    path: "/admin/settings/rules/add",
    meta: adddVbvCMC_NrP9WdlXJBtkFKpC7EsMBHOQ_45mfpqoJ_k14Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/settings/rules/add.vue")
  },
  {
    name: "admin-utilisateurs",
    path: "/admin/utilisateurs",
    meta: indexM_BeeI1yWwYmbwmXXBh2l6HtEIRAQINfuLOcnPWqYsEMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/utilisateurs/index.vue")
  },
  {
    name: "missions-benevolat",
    path: "/missions-benevolat",
    meta: indexlGtxNYW9UxCXoZ6vbN_G_pHccLPeZ8tY3gwAWto_NXwMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/missions-benevolat/index.vue")
  },
  {
    name: "admin-missions-id-dates",
    path: "/admin/missions/:id()/dates",
    meta: dates3p_jvQfsN5RcNhP7Of152DotkuClX5GLwN3tBvMaD_wMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/[id]/dates.vue")
  },
  {
    name: "admin-missions-id",
    path: "/admin/missions/:id()",
    meta: index7cQVT529nOehlUnmdKy84NnTS9s8xEgkA9_jPHUrD1wMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/[id]/index.vue")
  },
  {
    name: "admin-missions-id-lieux",
    path: "/admin/missions/:id()/lieux",
    meta: lieuxqix6BFAwqnpBU_45LJpod28bNmU0ngG75zEDckevfasFAMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/[id]/lieux.vue")
  },
  {
    name: "admin-missions-id-title",
    path: "/admin/missions/:id()/title",
    meta: titleN7BmfYD3S_45aIWbGyAG6Q2BZFTNgIlCK4d4pDjK5L50cMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/[id]/title.vue")
  },
  {
    name: "admin-organisations",
    path: "/admin/organisations",
    meta: index3wt4iU8kHNfCkf_45sNCDbaNz64hMHGbyjWzqKXLXPm2oMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/organisations/index.vue")
  },
  {
    name: "admin-statistics-missions",
    path: "/admin/statistics/missions",
    meta: missions6BysHbOAApINS6fDRMvsQAmLPRiwd8T_R3EA_452pC1SIMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/missions.vue")
  },
  {
    name: "admin-contenus-reseaux-add",
    path: "/admin/contenus/reseaux/add",
    meta: addtH78xybE0k2wW4XaDBzRfOWrTz4OfKdw1dFo1Bz5sWAMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/reseaux/add.vue")
  },
  {
    name: "admin-missions-id-visuel",
    path: "/admin/missions/:id()/visuel",
    meta: visuel9DfUBRVznS8LBqOgn_GtGVwPevieZlIHfvcJNcM5WLkMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/[id]/visuel.vue")
  },
  {
    name: "admin-participations",
    path: "/admin/participations",
    meta: indexTOYw20j0H0TANtC1Mkr4MVWLaTYGvkilW1XpVbsrwuMMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/participations/index.vue")
  },
  {
    name: "admin-settings-rules",
    path: "/admin/settings/rules",
    meta: indexvolQW_zXnknBAyhx8hfY9NP3KJwdGEThmDujRwdwafsMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/settings/rules/index.vue")
  },
  {
    name: "inscription-benevole",
    path: "/inscription/benevole",
    meta: indexjLMpKgk0obEyqujxGQj3HOjVbw4VZjcoj6iVnuhDr24Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/benevole/index.vue")
  },
  {
    name: "admin-contenus-domaines-add",
    path: "/admin/contenus/domaines/add",
    meta: addWQrntMSbbDxFyOpQ4dcplTOvZhhqzKTS_DaMyqrvAlUMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/domaines/add.vue")
  },
  {
    name: "admin-taxonomies-slug-add",
    path: "/admin/taxonomies/:slug()/add",
    meta: addF0IjYdvzCsLMrO2PK3fqCMmsjWoRGrPMt9BIftFRJ_QMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/taxonomies/[slug]/add.vue")
  },
  {
    name: "admin-contenus-activites-add",
    path: "/admin/contenus/activites/add",
    meta: addYZtwZa42utzqrkUnAOkeJfwqZdRi9vmav_45xzgj22mSAMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/activites/add.vue")
  },
  {
    name: "admin-contenus-reseaux",
    path: "/admin/contenus/reseaux",
    meta: indexa_lsTStYvqKdTqrSk0sse0LOWdsmQD3_Lg5wZwb5LewMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/reseaux/index.vue")
  },
  {
    name: "admin-statistics-conversions",
    path: "/admin/statistics/conversions",
    meta: conversionsN_45CP5oGIpbj2i0PjnPXgOge4b1wGy3gG6gSv8hjXfGcMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/conversions.vue")
  },
  {
    name: "admin-utilisateurs-id-edit",
    path: "/admin/utilisateurs/:id()/edit",
    meta: editn_45n_Dz77HiWN425rYHH7YMgE298vqFvXu7u4GbEArs0Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/utilisateurs/[id]/edit.vue")
  },
  {
    name: "politique-de-confidentialite",
    path: "/politique-de-confidentialite",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/politique-de-confidentialite.vue")
  },
  {
    name: "admin-contenus-domaines",
    path: "/admin/contenus/domaines",
    meta: indexTErOVgyjnzKqVPhFRnePbMjhu43NdK0_tsKNESXb5QAMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/domaines/index.vue")
  },
  {
    name: "admin-contenus-ressources-add",
    path: "/admin/contenus/ressources/add",
    meta: addRz_454UB5F9MYqToa3zYTlF0A32pLJJpMTGsFYnBqwpcQMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/ressources/add.vue")
  },
  {
    name: "admin-missions-id-benevoles",
    path: "/admin/missions/:id()/benevoles",
    meta: benevolesNLGqOPA6zHCVsqawOsg2aqNjs6UU8iaHIGllq0Vg_45dYMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/[id]/benevoles.vue")
  },
  {
    name: "admin-organisations-id-edit",
    path: "/admin/organisations/:id()/edit",
    meta: editaJ9lhNiJib2K9pvdm7xqNx1vWzsnFhgKRaddQg7qBOEMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/organisations/[id]/edit.vue")
  },
  {
    name: "admin-statistics-utilisateurs",
    path: "/admin/statistics/utilisateurs",
    meta: utilisateursftk6GABJd3XAVd1g2r_45ZI_45refsMERf1dLWZWVmHlyLgMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/utilisateurs.vue")
  },
  {
    name: "admin-taxonomies-slug",
    path: "/admin/taxonomies/:slug()",
    meta: indexMxCVwspsbjUuQYr1xeQ_45voOyBcQqSijwT5jFi8XJshsMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/taxonomies/[slug]/index.vue")
  },
  {
    name: "admin-utilisateurs-id",
    path: "/admin/utilisateurs/:id()",
    meta: indexSEeyegOLd_45hSRv7pYIQAuSXnU1dHs8l2cxZbbrtdWtsMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/utilisateurs/[id]/index.vue")
  },
  {
    name: "inscription-responsable",
    path: "/inscription/responsable",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/responsable/index.vue")
  },
  {
    name: "missions-benevolat-id",
    path: "/missions-benevolat/:id()",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/missions-benevolat/[id]/index.vue")
  },
  {
    name: "quiz-septembre-pour-apprendre",
    path: "/quiz/septembre-pour-apprendre",
    meta: septembre_45pour_45apprendredFwYOsKGNCtN7hkP2y6EvA_45f8dIw5oQ6UdSU4Q6QY34Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/quiz/septembre-pour-apprendre.vue")
  },
  {
    name: "admin-contenus-activites",
    path: "/admin/contenus/activites",
    meta: indexIsxRdFgAYBAtx51I_45v1eQAc6iTb5zQRVOmLNS5D8lc0Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/activites/index.vue")
  },
  {
    name: "admin-contenus-territoires-add",
    path: "/admin/contenus/territoires/add",
    meta: addTCRRqW_45O5fhW_PBhACUDtOZPpBcMvUNqhs5pccjBNfUMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/territoires/add.vue")
  },
  {
    name: "admin-organisations-id",
    path: "/admin/organisations/:id()",
    meta: indexV1Quc71cnbxeL8ejswvSi1_U1QhMCr34qxjqFmIHSLQMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/organisations/[id]/index.vue")
  },
  {
    name: "admin-settings-rules-id-edit",
    path: "/admin/settings/rules/:id()/edit",
    meta: editEGGOkzQg3HT97TWcAMT27i7liqwUTufjiGFD92TfzcYMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/settings/rules/[id]/edit.vue")
  },
  {
    name: "missions-benevolat-id-slug",
    path: "/missions-benevolat/:id()/:slug()",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/missions-benevolat/[id]/[slug].vue")
  },
  {
    name: "quiz-printemps-pour-la-planete",
    path: "/quiz/printemps-pour-la-planete",
    meta: printemps_45pour_45la_45planeteMM6WGG_45jPnHijB1L_45glRAyohdqbT0e16iwoCESZovxYMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/quiz/printemps-pour-la-planete.vue")
  },
  {
    name: "admin-contenus-ressources",
    path: "/admin/contenus/ressources",
    meta: index0TMpD2Pb3mHSlns7e1DpY_Ew66l5hmM4VoSzrt9S_P8Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/ressources/index.vue")
  },
  {
    name: "admin-statistics-participations",
    path: "/admin/statistics/participations",
    meta: participations4GYDe_45uNf02oMV82Gioq6Fw8t74QmrMb5Joe0QF_FkgMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/participations.vue")
  },
  {
    name: "charte-bon-fonctionnement",
    path: "/charte-bon-fonctionnement",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/charte-bon-fonctionnement/index.vue")
  },
  {
    name: "support-referents-activity-logs",
    path: "/support/referents/activity-logs",
    meta: activity_45logsyC5Fpk9AvXM2tSbbl6mNvWY_p9u7VKEXcuX0IXyB_450kMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/referents/activity-logs.vue")
  },
  {
    name: "admin-contenus-reseaux-id-edit",
    path: "/admin/contenus/reseaux/:id()/edit",
    meta: edit6yEiTwiTkNiRjfWPmH51fYOZeS8vthI8m1iPrYsJUj8Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/reseaux/[id]/edit.vue")
  },
  {
    name: "admin-contenus-territoires",
    path: "/admin/contenus/territoires",
    meta: indexM8Rd2cVWaET1bt07MYCzTaFGzgA2SQC5cZj6tUfgh2IMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/territoires/index.vue")
  },
  {
    name: "admin-missions-id-informations",
    path: "/admin/missions/:id()/informations",
    meta: informationsYFHFFb9dsBDnAFQjxDuqzLqaglo13XZAIpBi6yWHqdwMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/[id]/informations.vue")
  },
  {
    name: "admin-missions-id-responsables",
    path: "/admin/missions/:id()/responsables",
    meta: responsablespys25eAVhOtpGT5TGHIFQ7VT1RUeNQIc7rrhlj5F658Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/[id]/responsables.vue")
  },
  {
    name: "admin-contenus-domaines-id-edit",
    path: "/admin/contenus/domaines/:id()/edit",
    meta: editmJYkBRvSaXK90_icqFDNf4gWsJ3ZCQdzwG3bOGX1wJQMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/domaines/[id]/edit.vue")
  },
  {
    name: "admin-contenus-reseaux-id",
    path: "/admin/contenus/reseaux/:id()",
    meta: indexOKRPQk4V1_8FysKE2HNTCIfpjDogwMrQAHnVKObDFosMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/reseaux/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials",
    path: "/admin/contenus/testimonials",
    meta: indexMfYgtrFLgTzLB9E1EEB9mWH_45aGCeWDOFqgDifYYRyJsMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/testimonials/index.vue")
  },
  {
    name: "admin-statistics-indicateurs-cles",
    path: "/admin/statistics/indicateurs-cles",
    meta: indicateurs_45clesVyo7TM_rD5cuSsnOEyesbA3q2lETLL19fdhOlwGcz6MMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/indicateurs-cles.vue")
  },
  {
    name: "admin-taxonomies-slug-id-edit",
    path: "/admin/taxonomies/:slug()/:id()/edit",
    meta: editOqRYjZ7EMAGlPe_J3e8Dtf74yBefWhx8DIl9iaw03c4Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/taxonomies/[slug]/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-profile",
    path: "/inscription/benevole/step/profile",
    meta: profile_45m4mqdTlBACEGt8Wal8LF_45klMEnDQXr_p2RzVbEWtPgMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/benevole/step/profile.vue")
  },
  {
    name: "profile-charte-bon-fonctionnement",
    path: "/profile/charte-bon-fonctionnement",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/profile/charte-bon-fonctionnement.vue")
  },
  {
    name: "support-referents-waiting-actions",
    path: "/support/referents/waiting-actions",
    meta: waiting_45actionsKlpptDdr0MjGVO9C7Bgh473O9MuR_45GBElySKonc0a7wMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/referents/waiting-actions.vue")
  },
  {
    name: "admin-contenus-activites-id-edit",
    path: "/admin/contenus/activites/:id()/edit",
    meta: editDv1lwHLHtPnVisVk3ottu7WZ3S78QiJ8b98E5XxKzrkMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/activites/[id]/edit.vue")
  },
  {
    name: "admin-contenus-modeles-mission-add",
    path: "/admin/contenus/modeles-mission/add",
    meta: add0SYxN_45gdyMbXILGILHOOi8n6LQvte3eensNqQaNxUq0Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/modeles-mission/add.vue")
  },
  {
    name: "conditions-generales-d-utilisation",
    path: "/conditions-generales-d-utilisation",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/conditions-generales-d-utilisation.vue")
  },
  {
    name: "admin-contenus-activites-id",
    path: "/admin/contenus/activites/:id()",
    meta: indexzDGSzXONQaiXGanH8ZxobiPcNFVA0hQ3s8TTdEDTXx8Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/activites/[id]/index.vue")
  },
  {
    name: "admin-contenus-ressources-id-edit",
    path: "/admin/contenus/ressources/:id()/edit",
    meta: edit6VZ_45Uc3qT5V_45bjJ_45icNTpfGkOEyPdmvL_2vMa9acl3YMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/ressources/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-diffusions",
    path: "/admin/organisations/:id()/diffusions",
    meta: diffusionsMchfQ8r_45_s36d22mvj729LOKLaSCpJeDyXoV_i0sGGgMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/organisations/[id]/diffusions.vue")
  },
  {
    name: "admin-statistics-suivis-moderations",
    path: "/admin/statistics/suivis/moderations",
    meta: moderationsnokRaaritOTHmB_VQq5RS0kAY_PsmsPdzNK3lzT68YMMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/suivis/moderations.vue")
  },
  {
    name: "charte-bon-fonctionnement-benevoles",
    path: "/charte-bon-fonctionnement/benevoles",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/charte-bon-fonctionnement/benevoles.vue")
  },
  {
    name: "support-actions-google-api-indexing",
    path: "/support/actions/google-api-indexing",
    meta: google_45api_45indexingkXk73qF_A3eVYV0y6Id24S9_45Vf5nULm6SkhbWb6HK4gMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/actions/google-api-indexing.vue")
  },
  {
    name: "admin-contenus-modeles-mission",
    path: "/admin/contenus/modeles-mission",
    meta: indexj0MKAvi9IpcrTRKWSyGHq9JlLB6wtnRugx6_454z_45kafwMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/modeles-mission/index.vue")
  },
  {
    name: "admin-contenus-territoires-id-edit",
    path: "/admin/contenus/territoires/:id()/edit",
    meta: edit5UCVKYsAhE9tYUX4JCykvA4Gw6OFEeo5AZp20H1IfDIMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/territoires/[id]/edit.vue")
  },
  {
    name: "admin-statistics-organisations",
    path: "/admin/statistics/organisations",
    meta: indexWL4Wd6xJhhCgq1CNtn98MhTIL2c2xGpWkuN7b1MshNAMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/organisations/index.vue")
  },
  {
    name: "inscription-responsable-step-profile",
    path: "/inscription/responsable/step/profile",
    meta: profile5os_Id_45jEmKSwXnuXFTq1ZrQhnvSc4OwzKUMfaWVltQMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/responsable/step/profile.vue")
  },
  {
    name: "admin-contenus-territoires-id",
    path: "/admin/contenus/territoires/:id()",
    meta: indexEmmko_ReZAf8gRe1xkC62UeBMxR3FdKeD7LxKdsnPcsMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/territoires/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials-id-edit",
    path: "/admin/contenus/testimonials/:id()/edit",
    meta: edit8GCyMfegZIBuaZUkd9Ie6U0YcS8LH8Esxp_45ZLhTgS88Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/testimonials/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-missions-add",
    path: "/admin/organisations/:id()/missions/add",
    meta: add_rfiHRw3T7zEz4jixNvbg65QokY72NxLMNmVppV_LiQMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/organisations/[id]/missions/add.vue")
  },
  {
    name: "inscription-benevole-step-competences",
    path: "/inscription/benevole/step/competences",
    meta: competencesSF8W_45EIKlfoQ6M68m5eo04CiybAxPfLOI9DnrhVlzO0Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/benevole/step/competences.vue")
  },
  {
    name: "inscription-benevole-step-preferences",
    path: "/inscription/benevole/step/preferences",
    meta: preferences79Mmfswvj3F569GwrvrVLkT0fsy_45T_gZq0KYXpcbzDgMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/benevole/step/preferences.vue")
  },
  {
    name: "support-actions-search-archived-users",
    path: "/support/actions/search-archived-users",
    meta: search_45archived_45usersR_YMvoFnUBsPMbvVPkoisdzNvw5sJINylW4kPQQnRYcMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/actions/search-archived-users.vue")
  },
  {
    name: "support-contents-doublons-territoires",
    path: "/support/contents/doublons-territoires",
    meta: doublons_45territoirese3jIafbNa0zeAPIsJaDWVn7Zr6CxAnuBk2JzpmvOC44Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/contents/doublons-territoires.vue")
  },
  {
    name: "charte-bon-fonctionnement-responsables",
    path: "/charte-bon-fonctionnement/responsables",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/charte-bon-fonctionnement/responsables.vue")
  },
  {
    name: "support-actions-transfert-organisation",
    path: "/support/actions/transfert-organisation",
    meta: transfert_45organisationDdK05i14QMRoRGPU_OnZLAdxUkUDhy_6SNuBhl_45RwUMMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/actions/transfert-organisation.vue")
  },
  {
    name: "support-responsables-missions-outdated",
    path: "/support/responsables/missions-outdated",
    meta: missions_45outdated78_sZorppGFn_wbXECcvHRPdW1owGnClpCbCdvLPLLgMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/responsables/missions-outdated.vue")
  },
  {
    name: "admin-settings-rules-id-pending-items",
    path: "/admin/settings/rules/:id()/pending-items",
    meta: pending_45itemsL9yJELOJngFsSPrA10BZTp_45Ij1WqrqAm5211QVYqgBMMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/settings/rules/[id]/pending-items.vue")
  },
  {
    name: "support-actions-user-reset-context-role",
    path: "/support/actions/user-reset-context-role",
    meta: user_45reset_45context_45roleuvobKi1LXC5mYgn0qFkH5inYz_45Noggq_45DN_45pi0axyNEMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/actions/user-reset-context-role.vue")
  },
  {
    name: "support-contents-doublons-organisations",
    path: "/support/contents/doublons-organisations",
    meta: doublons_45organisationsmL5EKdmXv3C5_VAexsekxAW7WOuQWuZ5Iepx_5VyWVsMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/contents/doublons-organisations.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id-edit",
    path: "/admin/contenus/modeles-mission/:id()/edit",
    meta: editV809MJOB8tqU_ZShXGZlRSgvBJszBRnGy72DiPO5GXMMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/modeles-mission/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-disponibilites",
    path: "/inscription/benevole/step/disponibilites",
    meta: disponibilitesV4aYHyphTdwm4_qnS37jGBPpzykEDZl1boizIwOkebUMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/benevole/step/disponibilites.vue")
  },
  {
    name: "support-actions-user-reset-password-link",
    path: "/support/actions/user-reset-password-link",
    meta: user_45reset_45password_45link10wXmspzbze9Zppk_45YbFw5CVYtQvJq8nUdRY3fau9doMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/actions/user-reset-password-link.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id",
    path: "/admin/contenus/modeles-mission/:id()",
    meta: indexQTvGeck19EAsgwFgds2fcsXdHM6j7FwpPoK7hBgKxlEMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/contenus/modeles-mission/[id]/index.vue")
  },
  {
    name: "inscription-responsable-step-collectivite",
    path: "/inscription/responsable/step/collectivite",
    meta: collectivites3HavC0ZU3RCZd328IERsqKufzMd8Lj_wcnxabBfgJAMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/responsable/step/collectivite.vue")
  },
  {
    name: "inscription-responsable-step-organisation",
    path: "/inscription/responsable/step/organisation",
    meta: organisation7r_454fXwb1eXqV3aJgd_45_pkd8fKb8VsuRiS7JwZzQpYUMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/responsable/step/organisation.vue")
  },
  {
    name: "admin-missions-id-benevoles-informations",
    path: "/admin/missions/:id()/benevoles-informations",
    meta: benevoles_45informationsiuVD6VeAKj5xcbY2zoh6old55mqjPRIx7R4L_45cXq6pMMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/[id]/benevoles-informations.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-entrant",
    path: "/admin/statistics/api-engagement/trafic-entrant",
    meta: trafic_45entrantWhAO0ss6MA3EA9v6GSPfLWygw05asl7o7GmubEEgfGMMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/api-engagement/trafic-entrant.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-sortant",
    path: "/admin/statistics/api-engagement/trafic-sortant",
    meta: trafic_45sortantkw7njw6ElHsQWsUI0yt5v5_455iUHEAP3ib2sgg8VgIAAMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/api-engagement/trafic-sortant.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles",
    path: "/admin/missions/:id()/trouver-des-benevoles",
    meta: indexPt1KI7mrqwUjzeYd9yy96O9mF1QnqPm3AvGIVk6qbV8Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/[id]/trouver-des-benevoles/index.vue")
  },
  {
    name: "admin-statistics-departements-missions-perimees",
    path: "/admin/statistics/departements/missions-perimees",
    meta: missions_45perimeesvj_UFJSMB_45YFgsqbH6Zjg01C1jH45ZnXlpHX7mV4JhYMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/departements/missions-perimees.vue")
  },
  {
    name: "admin-statistics-departements-missions-a-valider",
    path: "/admin/statistics/departements/missions-a-valider",
    meta: missions_45a_45validerPnfJ7fyhORKXd7Or_45J0DrGzid9XoGKGhxd2cdXl0s_MMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/departements/missions-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-missions-perimees",
    path: "/admin/statistics/organisations/missions-perimees",
    meta: missions_45perimeesh4XZXxUIVaUlKQY_45oG7fx3EtJCpfUGwtKS39R_45HnzGgMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/organisations/missions-perimees.vue")
  },
  {
    name: "inscription-responsable-step-organisation-images",
    path: "/inscription/responsable/step/organisation-images",
    meta: organisation_45imagesOugXxGWJ0SU2iqgjNjqidBCEp4eOfGAuF38LQ0uwkn4Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/responsable/step/organisation-images.vue")
  },
  {
    name: "inscription-responsable-step-organisation-details",
    path: "/inscription/responsable/step/organisation-details",
    meta: organisation_45details4BCP1wbuNG21CYP_45l6c5vjywqeg9H42oSAXEdaJsgvQMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/responsable/step/organisation-details.vue")
  },
  {
    name: "support-responsables-participations-to-be-treated",
    path: "/support/responsables/participations-to-be-treated",
    meta: participations_45to_45be_45treated11_45w1gV24wzPxeOGo6PBdVlH_DEQ_45Rc0F_fqrR62al4Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/support/responsables/participations-to-be-treated.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles-redirect",
    path: "/admin/missions/:id()/trouver-des-benevoles/redirect",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue")
  },
  {
    name: "admin-statistics-departements-organisations-a-valider",
    path: "/admin/statistics/departements/organisations-a-valider",
    meta: organisations_45a_45valideraXaZQzan0tEWY5DdLdKGCvscRz1NiCywCPEr9wWl5CwMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/departements/organisations-a-valider.vue")
  },
  {
    name: "inscription-responsable-step-charte-bon-fonctionnement",
    path: "/inscription/responsable/step/charte-bon-fonctionnement",
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/responsable/step/charte-bon-fonctionnement.vue")
  },
  {
    name: "inscription-responsable-step-collectivite-confirmation",
    path: "/inscription/responsable/step/collectivite-confirmation",
    meta: collectivite_45confirmationdjtRzN8n3aa8pvH_45XZQ3yPQ9c_uW8zulUvJtKF88NtcMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/responsable/step/collectivite-confirmation.vue")
  },
  {
    name: "inscription-responsable-step-organisation-confirmation",
    path: "/inscription/responsable/step/organisation-confirmation",
    meta: organisation_45confirmationDeiH2BF10XFWpfxKkRjfmvJPuuWxAJsPBNzOL_45HxwE8Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/inscription/responsable/step/organisation-confirmation.vue")
  },
  {
    name: "admin-statistics-organisations-participations-a-valider",
    path: "/admin/statistics/organisations/participations-a-valider",
    meta: participations_45a_45validerRsa8w8RDup5s9vwc9yhRxuvQvRpnawgsFaKNHEjM6_AMeta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/organisations/participations-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-participations-refusees-annulees",
    path: "/admin/statistics/organisations/participations-refusees-annulees",
    meta: participations_45refusees_45annuleeskc5V5N868TqPd_45XS3dS_a9xAx2hrq4MmxuPYmqwick8Meta || {},
    component: () => import("/build/a4f6670b-1e46-400c-b7fa-1c373e07ddf8/pages/admin/statistics/organisations/participations-refusees-annulees.vue")
  },
  {
    name: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTkMeta?.name,
    path: "/register/volontaire/:pathMatch(.*)",
    component: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTk
  },
  {
    name: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTkMeta?.name,
    path: "/register/responsable/:pathMatch(.*)",
    component: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTk
  },
  {
    name: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTkMeta?.name,
    path: "/user/settings",
    component: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTk
  },
  {
    name: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTkMeta?.name,
    path: "/user/:pathMatch(.*)",
    component: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTk
  },
  {
    name: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTkMeta?.name,
    path: "/dashboard/structure/:pathMatch(.*)",
    component: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTk
  },
  {
    name: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTkMeta?.name,
    path: "/dashboard/mission/:pathMatch(.*)",
    component: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTk
  },
  {
    name: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTkMeta?.name,
    path: "/dashboard/participation/:pathMatch(.*)",
    component: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTk
  },
  {
    name: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTkMeta?.name,
    path: "/dashboard/profile/:pathMatch(.*)",
    component: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTk
  },
  {
    name: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTkMeta?.name,
    path: "/dashboard/reseaux/:pathMatch(.*)",
    component: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTk
  },
  {
    name: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTkMeta?.name,
    path: "/inscription/organisation",
    component: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTk
  },
  {
    name: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTkMeta?.name,
    path: "/statistiques",
    component: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTk
  },
  {
    name: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTkMeta?.name,
    path: "/activites/accompagnement-aux-activites-sportives",
    component: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTk
  },
  {
    name: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTkMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub9Eees_45vJ_5X461VT3Ordp1LvdO7q1t9VsBVTjXxPwTk
  }
]